import { useEffect, useState } from "react";

import firebase from "firebase/app";
import { GardeningTaskGardenerViewDocument } from "./gardening-task-gardener-view.model";

export const useGardeningTask = (gardenerId: string, gardeningTaskId: string) => {
    const [state, setState] = useState<GardeningTaskGardenerViewDocument | null>();

    useEffect(() => {
        setState(undefined);

        return firebase.firestore().collection("helpers").doc(gardenerId).collection("gardeningTasks").doc(gardeningTaskId).onSnapshot(document => {
            if ( !document.exists ) return setState(null);

            setState({ id: document.id, ...document.data() } as GardeningTaskGardenerViewDocument);
        }, error => {
            console.error(error);

            setState(null);
        });

    }, [gardenerId, gardeningTaskId]);

    return state;
}

export const useGardeningTasksByStatus = (gardenerId: string, status: GardeningTaskGardenerViewDocument["status"]) => {
    const [state, setState] = useState<GardeningTaskGardenerViewDocument[]>();

    useEffect(() => {
        setState(undefined);

        return firebase.firestore().collection("helpers").doc(gardenerId).collection("gardeningTasks").where("status", "==", status).onSnapshot(snapshot => {
            const documents = snapshot.docs.map(document => ({ id: document.id, ...document.data() } as GardeningTaskGardenerViewDocument));

            setState(documents);
        });

    }, [gardenerId, status]);

    return state;
}

export const useGardeningTasksByCustomerIdAndStatus = (gardenerId: string, customerId: string, status: GardeningTaskGardenerViewDocument["status"]) => {
    const [state, setState] = useState<GardeningTaskGardenerViewDocument[]>();

    useEffect(() => {
        setState(undefined);

        return firebase.firestore().collection("helpers").doc(gardenerId).collection("gardeningTasks").where("customer.id", "==", customerId).where("status", "==", status).onSnapshot(snapshot => {
            const documents = snapshot.docs.map(document => ({ id: document.id, ...document.data() } as GardeningTaskGardenerViewDocument));

            setState(documents);
        });

    }, [gardenerId, customerId, status]);

    return state;
}
